import React, { useEffect, useState } from 'react'
import { Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { COLORS } from 'src/utils/Themes/colors'
import DetailedView from 'src/components/RiskReports/PremuimAndClaims/DetailedView'
import BarCharts from 'src/components/common/charts/BarCharts'
import Modal from 'src/components/common/Modal'

const CHART_COLORS = [
  COLORS?.BAR_CHART_COLOR1,
  COLORS?.BAR_CHART_COLOR2,
  COLORS?.BAR_CHART_COLOR3,
  COLORS?.BAR_CHART_COLOR3,
]

const PremiumAndClaims = ({ data, chartHeight, series, categories, type }) => {
  const classes = useStyles()
  const [selectedYear] = useState()
  const [premiumClaimToYears, setPremiumClaimToYears] = useState([])
  const [modalOpen, setModalClose] = useState(false)

  const handleDetailedView = () => {
    setModalClose(true)
  }

  const CloseModal = () => {
    setModalClose(false)
  }

  const fetchChartDate = (cutoffYear) => {
    const cuttOffData = data?.slice(0, cutoffYear)
    if (cuttOffData) {
      setPremiumClaimToYears(cuttOffData)
    }
  }

  useEffect(() => {
    if (data) fetchChartDate(selectedYear)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedYear, data])

  return (
    <div className='premiumAndClaimsParent'>
      <div className={classes.root}>
        {modalOpen ? (
          <Modal
            bgcolor={'#FFF'}
            ordered={modalOpen}
            width={'60%'}
            left={'20%'}
            top={'14%'}
            modelClosed={CloseModal}
          >
            <DetailedView
              closefunction={CloseModal}
              data={premiumClaimToYears}
              selectedYear={selectedYear}
              totalData={data}
              type={type}
            />
          </Modal>
        ) : null}
        <div className={classes.cardMainContainer}>
          <div>
            <h2 className={classes.title}>
              <span>
                Premium & Claims <br />
                Over{' '}
              </span>
              <span classes={{ root: classes.menuItem }}>
                {data === null ? 0 : data?.length}
              </span>
              <span> Years</span>
            </h2>
            {data && data?.length === 0 ? null : (
              <BarCharts
                categories={categories}
                series={series}
                height={chartHeight}
                colors={CHART_COLORS}
              />
            )}
            {series?.length > 0 && (
              <Button
                id='detailed-view'
                variant='text'
                classes={{ text: classes.btnLabel }}
                onClick={handleDetailedView}
              >
                Detailed View
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default PremiumAndClaims

const useStyles = makeStyles({
  root: {
    width: '100%',
    boxSizing: 'border-box',
    borderRadius: '10px',
    textAlign: 'center',
  },
  title: {
    fontSize: '18px',
    fontWeight: '600',
    lineHeight: '22px',
    padding: '0px 32px',
    color: '#333333',
    '& .MuiSelect-select': {
      padding: '0 14px 0 10px',
      fontWeight: 600,
      borderBottom: '1px solid #bbbbbb',
      borderRadius: 0,
    },
    '& fieldset': {
      border: '0px',
    },
  },
  cardMainContainer: {
    borderRadius: '10px',
    padding: '6px',
  },
  menuItem: {
    paddingLeft: '16px',
    '&.MuiListItem-gutters': {
      paddingLeft: '16px !important',
    },
  },
  btnLabel: {
    textTransform: 'capitalize',
    color: '#02A9F4',
    textDecoration: 'underline',
    marginTop: '-15px',
  },
})
